import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center" }
const _hoisted_2 = { class: "leading-17 mb-3" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-3 gap-7" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 gap-7 mt-7" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col mt-7"
}
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "transition-all duration-300" }
const _hoisted_8 = { class: "transition-all duration-300" }
const _hoisted_9 = {
  key: 0,
  class: "overflow-x-auto mb-7"
}
const _hoisted_10 = { class: "align-middle inline-block min-w-full" }
const _hoisted_11 = { class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg" }
const _hoisted_12 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_13 = { class: "bg-gray-50" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = { class: "ml-1 flex flex-col" }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = { class: "ml-1 flex flex-col" }
const _hoisted_18 = { class: "flex items-center" }
const _hoisted_19 = { class: "ml-1 flex flex-col" }
const _hoisted_20 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_21 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_22 = ["href", "title"]
const _hoisted_23 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_24 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_25 = { class: "inline-flex items-center justify-start leading-6 py-2" }
const _hoisted_26 = { class: "font-bold mr-1" }
const _hoisted_27 = { class: "leading-6 py-2" }
const _hoisted_28 = { class: "flex flex-col" }
const _hoisted_29 = { class: "text-sm font-bold leading-4" }
const _hoisted_30 = { class: "text-sm font-normal leading-4 mt-2" }
const _hoisted_31 = {
  key: 0,
  class: "py-2"
}
const _hoisted_32 = {
  key: 0,
  class: "inline-block mr-2 text-sm leading-6"
}
const _hoisted_33 = { class: "font-bold" }
const _hoisted_34 = {
  key: 1,
  class: "inline-block mr-2 text-sm leading-6"
}
const _hoisted_35 = { class: "font-bold" }
const _hoisted_36 = {
  key: 2,
  class: "inline-block mr-2 text-sm leading-6"
}
const _hoisted_37 = { class: "font-bold" }
const _hoisted_38 = {
  key: 3,
  class: "inline-block mr-2 text-sm leading-6"
}
const _hoisted_39 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_section = _resolveComponent("app-section")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_card_kpi = _resolveComponent("card-kpi")!
  const _component_bounce_metrics = _resolveComponent("bounce-metrics")!
  const _component_card_group = _resolveComponent("card-group")!
  const _component_card_list_item = _resolveComponent("card-list-item")!
  const _component_mail_preview_content = _resolveComponent("mail-preview-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_section, { class: "py-3 bg-light-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_app_button, { "button-style": "breadcrumb" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("pages.mail.viewMail")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_app_section, { class: "pt-5 pb-8 bg-light-2" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.mail.name), 1),
          _createVNode(_component_app_button, { onClick: _ctx.duplicateMail }, {
            left: _withCtx(() => [
              _createVNode(_component_app_icon, {
                name: "Duplicate",
                "fill-type": "stroke",
                class: "mr-1",
                size: "5"
              })
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(_ctx.$t("pages.mail.duplicate")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        (_ctx.mailStats !== undefined)
          ? (_openBlock(), _createBlock(_component_card_group, {
              key: 0,
              title: _ctx.$t('general.performance')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_card_kpi, {
                    header: 
                        `${_ctx.mailStats.total_sent} ${_ctx.$t(
                            'pages.mail.totalMailsSent'
                        )}:`
                    ,
                    text: `${_ctx.mailStats.open_rate.toFixed(1)}%`,
                    tooltip: _ctx.$t('pages.mails.tooltips.totalMailsSentWithOpenRate')
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_app_icon, { name: "MailOpen" })
                    ]),
                    _: 1
                  }, 8, ["header", "text", "tooltip"]),
                  _createVNode(_component_card_kpi, {
                    header: _ctx.$t('pages.mails.numberOfConversions'),
                    value: _ctx.mailStats.total_conversions,
                    tooltip: _ctx.$t('pages.mails.tooltips.numberOfConversions')
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_app_icon, { name: "Conversion" })
                    ]),
                    _: 1
                  }, 8, ["header", "value", "tooltip"]),
                  _createVNode(_component_card_kpi, {
                    header: _ctx.$t('pages.mails.totalRevenue'),
                    currency: _ctx.currency,
                    value: parseFloat(_ctx.mailStats.total_revenue.toFixed(1)),
                    tooltip: _ctx.$t('pages.mails.tooltips.totalRevenue')
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_app_icon, { name: "CurrencyDollar" })
                    ]),
                    _: 1
                  }, 8, ["header", "currency", "value", "tooltip"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_card_kpi, {
                    header: _ctx.$t('pages.mail.clickThroughRate'),
                    text: `${_ctx.clickThroughRate.toFixed(1)}%`,
                    tooltip: _ctx.$t('pages.mails.tooltips.clickThroughRate')
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_app_icon, { name: "MailOpen" })
                    ]),
                    _: 1
                  }, 8, ["header", "text", "tooltip"]),
                  _createVNode(_component_card_kpi, {
                    header: _ctx.$t('pages.mail.clickToOpenRate'),
                    text: `${_ctx.clickToOpenRate.toFixed(1)}%`,
                    tooltip: _ctx.$t('pages.mails.tooltips.clickToOpenRate')
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_app_icon, { name: "MailOpen" })
                    ]),
                    _: 1
                  }, 8, ["header", "text", "tooltip"])
                ]),
                (_ctx.mail.trackables || _ctx.bounceData || _ctx.bounceLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_app_button, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showBounceMetrics = !_ctx.showBounceMetrics)),
                          "button-style": "secondary",
                          class: "text-sm"
                        }, {
                          left: _withCtx(() => [
                            (!_ctx.showBounceMetrics)
                              ? (_openBlock(), _createBlock(_component_app_icon, {
                                  key: 0,
                                  size: "4",
                                  class: "mr-1",
                                  name: "ChevronDown"
                                }))
                              : (_openBlock(), _createBlock(_component_app_icon, {
                                  key: 1,
                                  size: "4",
                                  class: "mr-1",
                                  name: "ChevronUp"
                                }))
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString(_ctx.showBounceMetrics
                                ? _ctx.$t("general.viewLess")
                                : _ctx.$t("general.viewMore")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_bounce_metrics, {
                          "bounce-data": _ctx.bounceData,
                          loading: _ctx.bounceLoading
                        }, null, 8, ["bounce-data", "loading"])
                      ], 512), [
                        [_vShow, _ctx.showBounceMetrics && (_ctx.bounceData || _ctx.bounceLoading)]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_8, [
                        (_ctx.mail.trackables)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("table", _hoisted_12, [
                                    _createElementVNode("thead", _hoisted_13, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", {
                                          scope: "col",
                                          class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none",
                                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSort('url')))
                                        }, [
                                          _createElementVNode("div", _hoisted_14, [
                                            _createTextVNode(_toDisplayString(_ctx.$t("pages.mail.link")) + " ", 1),
                                            _createElementVNode("div", _hoisted_15, [
                                              _createVNode(_component_app_icon, {
                                                name: "ChevronUp",
                                                size: "3",
                                                class: _normalizeClass(_ctx.sortBy === 'url' && _ctx.sortDirection === 'asc' ? 'text-blue-600' : 'text-gray-300')
                                              }, null, 8, ["class"]),
                                              _createVNode(_component_app_icon, {
                                                name: "ChevronDown",
                                                size: "3",
                                                class: _normalizeClass(_ctx.sortBy === 'url' && _ctx.sortDirection === 'desc' ? 'text-blue-600' : 'text-gray-300')
                                              }, null, 8, ["class"])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("th", {
                                          scope: "col",
                                          class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none",
                                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSort('hits')))
                                        }, [
                                          _createElementVNode("div", _hoisted_16, [
                                            _createTextVNode(_toDisplayString(_ctx.$t("pages.mail.totalClicks")) + " ", 1),
                                            _createElementVNode("div", _hoisted_17, [
                                              _createVNode(_component_app_icon, {
                                                name: "ChevronUp",
                                                size: "3",
                                                class: _normalizeClass(_ctx.sortBy === 'hits' && _ctx.sortDirection === 'asc' ? 'text-blue-600' : 'text-gray-300')
                                              }, null, 8, ["class"]),
                                              _createVNode(_component_app_icon, {
                                                name: "ChevronDown",
                                                size: "3",
                                                class: _normalizeClass(_ctx.sortBy === 'hits' && _ctx.sortDirection === 'desc' ? 'text-blue-600' : 'text-gray-300')
                                              }, null, 8, ["class"])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("th", {
                                          scope: "col",
                                          class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none",
                                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSort('unique_hits')))
                                        }, [
                                          _createElementVNode("div", _hoisted_18, [
                                            _createTextVNode(_toDisplayString(_ctx.$t("pages.mail.uniqueClicks")) + " ", 1),
                                            _createElementVNode("div", _hoisted_19, [
                                              _createVNode(_component_app_icon, {
                                                name: "ChevronUp",
                                                size: "3",
                                                class: _normalizeClass(_ctx.sortBy === 'unique_hits' && _ctx.sortDirection === 'asc' ? 'text-blue-600' : 'text-gray-300')
                                              }, null, 8, ["class"]),
                                              _createVNode(_component_app_icon, {
                                                name: "ChevronDown",
                                                size: "3",
                                                class: _normalizeClass(_ctx.sortBy === 'unique_hits' && _ctx.sortDirection === 'desc' ? 'text-blue-600' : 'text-gray-300')
                                              }, null, 8, ["class"])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("tbody", _hoisted_20, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedTrackables, (trackable) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: trackable.id
                                        }, [
                                          _createElementVNode("td", _hoisted_21, [
                                            _createElementVNode("a", {
                                              href: trackable.url,
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                              class: "text-blue-600 hover:text-blue-800 underline",
                                              title: trackable.url
                                            }, _toDisplayString(_ctx.truncateUrl(trackable.url)), 9, _hoisted_22)
                                          ]),
                                          _createElementVNode("td", _hoisted_23, _toDisplayString(trackable.hits), 1),
                                          _createElementVNode("td", _hoisted_24, _toDisplayString(trackable.unique_hits), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 512), [
                        [_vShow, _ctx.showBounceMetrics]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_app_section, { class: "py-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_card_group, {
          title: _ctx.$t('pages.mail.configuration')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_card_list_item, {
              title: _ctx.$t('pages.mail.receiver'),
              status: "success",
              class: "mb-5 text-sm",
              "action-disabled": true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_app_icon, {
                    name: "Users",
                    size: "5",
                    class: "mr-1"
                  }),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("pages.mail.segment")) + ":", 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.listLabel) + " (" + _toDisplayString(_ctx.listLabelCount) + ") ", 1)
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(_component_card_list_item, {
              title: _ctx.$t('pages.mail.sender'),
              status: "success",
              class: "mb-5 text-sm",
              "action-disabled": true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, [
                  _createTextVNode(_toDisplayString(_ctx.mail.fromName) + " ", 1),
                  (_ctx.mail.fromAddress)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("-")
                      ], 64))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.mail.fromAddress), 1)
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(_component_card_list_item, {
              title: _ctx.$t('pages.mail.subject'),
              status: "success",
              class: "mb-5 text-sm",
              "action-disabled": true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.mail.subject || "–"), 1),
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("pages.mail.preheader")) + " " + _toDisplayString(_ctx.mail.preheaderText || "–"), 1)
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(_component_card_list_item, {
              title: _ctx.$t('pages.mail.content'),
              status: _ctx.mail.customHtml.length ? 'success' : 'danger',
              class: "mb-5 text-sm",
              "action-disabled": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_mail_preview_content, {
                  html: _ctx.mail.customHtml
                }, null, 8, ["html"])
              ]),
              _: 1
            }, 8, ["title", "status"]),
            _createVNode(_component_card_list_item, {
              title: _ctx.$t('pages.mail.utmTitle'),
              status: "success",
              class: "mb-5 text-sm",
              "action-disabled": true
            }, {
              default: _withCtx(() => [
                (!!_ctx.mail.utmTags)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      (!!_ctx.mail.utmTags.utmSource)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("pages.mail.source")) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.mail.utmTags.utmSource), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!!_ctx.mail.utmTags.utmMedium)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("pages.mail.medium")) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.mail.utmTags.utmMedium), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!!_ctx.mail.utmTags.utmCampaign)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t("pages.mail.name")) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.mail.utmTags.utmCampaign), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!!_ctx.mail.utmTags.utmContent)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                            _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("pages.mail.content")) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.mail.utmTags.utmContent), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["title"])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    })
  ], 64))
}